export default __webpack_public_path__ + "static/media/truck.3a64fc5c.png";